import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import policyActions from '../policy/policyActions';

import PolicyList from '../policy/PolicyList';
import { Page, PageContent, PageHeader } from '../components/common';
import { ensureUserHasRole } from '../auth/authComponents';
import { SecurityRoles } from '../common/utils';

interface Props {
	className?: string;
	policies: CustomerPolicy[];
	tempPolicyDocumentUrl: string;
	actions: any;
	history: any;
	match: any;
}
interface State {
	loading: boolean;
}
class PoliciesPage extends React.Component<Props, State> {
	state = {
		loading: true
	};

	componentDidMount() {
		this.props.actions.fetchCustomerPolicies(this.props.match.params.userId)
			.then(() => this.setState({ loading: false }));
	}

	onDownloadClick = (e: any, row: CustomerPolicy) => {
		e.stopPropagation(); // make sure to stop click propogation or the row click kicks in
		this.props.actions.fetchCustomerPolicyDocumentUrl(this.props.match.params.userId, row.id)
			.then(() => {
				window.open(this.props.tempPolicyDocumentUrl);
			});
	}

	render() {
		return (
			<Page title="Policies">
				<PageContent>
					<PageHeader title="Your policies" />
					<PolicyList policies={this.props.policies} onDownloadClick={this.onDownloadClick} loading={this.state.loading} />
				</PageContent>
			</Page>
		);
	}
}
function mapStateToProps(state: any) {
	return {
		policies: state.policy.policies,
		tempPolicyDocumentUrl: state.policy.tempPolicyDocumentUrl,
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...policyActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const ConnectedPage = connect(mapStateToProps, mapDispatchToProps)(PoliciesPage);
export default ensureUserHasRole(ConnectedPage as any, [SecurityRoles.Customer]);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/user/PoliciesPage.tsx